const DB_NAME = 'SecondBrainShareDB';
const DB_VERSION = 1;
const STORE_NAME = 'shares';

const openDB = () => {
    return new Promise((resolve, reject) => {
        if (!('indexedDB' in window)) {
            return reject(new Error('IndexedDB not supported'));
        }
        const request = indexedDB.open(DB_NAME, DB_VERSION);
        request.onupgradeneeded = (event) => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME, { keyPath: 'id' });
            }
        };
        request.onsuccess = (event) => resolve(event.target.result);
        request.onerror = (event) => reject(event.target.error);
    });
};

export const getShareById = async (shareId) => {
    try {
        const db = await openDB();
        return new Promise((resolve, reject) => {
            const tx = db.transaction(STORE_NAME, 'readonly');
            const store = tx.objectStore(STORE_NAME);
            const req = store.get(shareId);
            req.onsuccess = () => resolve(req.result || null);
            req.onerror = () => reject(req.error);
        });
    } catch (err) {
        console.error('[ShareDB] Error getting share by id:', err);
        return null;
    }
};

export const deleteShareById = async (shareId) => {
    try {
        const db = await openDB();
        return new Promise((resolve, reject) => {
            const tx = db.transaction(STORE_NAME, 'readwrite');
            const store = tx.objectStore(STORE_NAME);
            const req = store.delete(shareId);
            req.onsuccess = () => resolve(true);
            req.onerror = () => reject(req.error);
        });
    } catch (err) {
        console.error('[ShareDB] Error deleting share by id:', err);
        return false;
    }
};

export const getLatestPendingShare = async (maxAgeMs = 30 * 60 * 1000) => {
    try {
        const db = await openDB();
        return new Promise((resolve, reject) => {
            const tx = db.transaction(STORE_NAME, 'readonly');
            const store = tx.objectStore(STORE_NAME);
            const req = store.getAll();
            req.onsuccess = () => {
                const list = req.result || [];
                if (list.length === 0) return resolve(null);
                
                // Sort by timestamp descending
                list.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
                const latest = list[0];
                const now = Date.now();
                if (latest && latest.timestamp && (now - latest.timestamp <= maxAgeMs)) {
                    resolve(latest);
                } else {
                    resolve(null);
                }
            };
            req.onerror = () => reject(req.error);
        });
    } catch (err) {
        console.error('[ShareDB] Error getting latest pending share:', err);
        return null;
    }
};

export const cleanOldShares = async (maxAgeMs = 24 * 60 * 60 * 1000) => {
    try {
        const db = await openDB();
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const store = tx.objectStore(STORE_NAME);
        const req = store.getAll();
        req.onsuccess = () => {
            const list = req.result || [];
            const now = Date.now();
            for (const item of list) {
                if (item.timestamp && (now - item.timestamp > maxAgeMs)) {
                    store.delete(item.id);
                }
            }
        };
    } catch (err) {
        console.warn('[ShareDB] Clean error:', err);
    }
};
